import React, { FC, useEffect, useRef, useState } from 'react'
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react'
import { HistoryProps } from './types/History.types'
import { useHistoryScroll } from './hooks/useHistoryScroll'
import './History.scss'

import HistoryTabs from './HistoryTabs/HistoryTabs'
import HistoryBlock from './HistoryBlock/HistoryBlock'

const History: FC<HistoryProps> = (props) => {
  const isExperienceEditor = isEditorActive();
  const cluster = props?.fields?.cluster;
  const { scroll, CustomScrollMarker } = useHistoryScroll()

  const [historyIndex, setHistoryIndex] = useState(0)
  const [selectedTab, setSelectedTab] = useState('')
  const [tabs, setTabs] = useState<string[]>([])
  const [isScrolling, setIsScrolling] = useState(false)

  const ref = useRef<any>(null);

  useEffect(() => {
    if (!cluster) return

    let formattedTabs: string[] = []
    cluster?.map((cluster) => {
      formattedTabs.push(cluster?.fields?.title?.value)
    })
    setTabs(formattedTabs)
  }, [cluster])

  useEffect(() => {
    if (tabs.length > 0) setSelectedTab(tabs[0])
  }, [tabs])

  return (
    <div className={'history'}>
      <CustomScrollMarker topOffset={10} innerRef={ref} />

      <div>
        <HistoryTabs
          index={historyIndex}
          setIndex={setHistoryIndex}
          setTab={setSelectedTab}
          tabs={tabs}
          onScroll={() => {
            setIsScrolling(true)
            scroll(ref)
            setTimeout(() => {
              setIsScrolling(false)
            }, 500)
          }}
        />
      </div>

      <div className={'History__tabs_container'}>
        <div className="History__line" />

        {cluster?.map((item, selfIndex) => (
          <div key={selfIndex}>
            {(isExperienceEditor || tabs[selfIndex] === selectedTab) &&
              item.fields.entries.map((entry, index) => {
                return (
                  <HistoryBlock
                    key={index}
                    title={entry.fields.title}
                    description={entry.fields.description}
                    icon={entry.fields.icon}
                    image={entry.fields.image}
                    year={entry.fields.year}
                    index={index}
                    isScrolling={isScrolling}
                  />
                )
              })}
          </div>
        ))}
      </div>

      <HistoryTabs
        index={historyIndex}
        setIndex={setHistoryIndex}
        setTab={setSelectedTab}
        tabs={tabs}
        borderTop={false}
        onScroll={() => {
          setIsScrolling(true)
          scroll(ref)
          setTimeout(() => {
            setIsScrolling(false)
          }, 500)
        }}
      />
    </div>
  )
}

export default History
